export const OWNER_LEVEL_ROLES = ['owner', 'manager'] as const;
export const ADMIN_PORTAL_ROLES = ['owner', 'manager', 'employee'] as const;

export function normalizeRoleName(role?: string | null): string {
  return role?.toLowerCase() ?? '';
}

export function isOwnerLevelRole(role?: string | null): boolean {
  const normalized = normalizeRoleName(role);
  return OWNER_LEVEL_ROLES.includes(normalized as (typeof OWNER_LEVEL_ROLES)[number]);
}

export function hasAdminPortalAccess(role?: string | null): boolean {
  const normalized = normalizeRoleName(role);
  return ADMIN_PORTAL_ROLES.includes(normalized as (typeof ADMIN_PORTAL_ROLES)[number]);
}

export function hasRequiredRole(
  userRole?: string | null,
  requiredRoles?: readonly string[]
): boolean {
  if (!requiredRoles || requiredRoles.length === 0) {
    return true;
  }
  const normalized = normalizeRoleName(userRole);
  return requiredRoles.some((role) => normalizeRoleName(role) === normalized);
}
